export default __webpack_public_path__ + "static/media/ss-burger.e1828728.png";